import { Locale } from "../Locale.js";
import { getPathInLocale } from "./getPathInLocale.js";

export function getReviewsPath(locale: Locale): string {
	return getPathInLocale(locale, {
		[Locale.cs]: "/#recenze",
	});
}
